module.exports = __webpack_public_path__ + "static/img/sbmg.013900a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sjcw/sbmg.png
// module id = 0nu+
// module chunks = 26